import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { DwsPermissionDirectiveModule } from '@util/directives/dwsPermission/dws-permission.module';
import { TranslateModule } from '@ngx-translate/core';
import { FeatureToggleModule } from "../../modules/feature-toggle/feature-toggle.module";
import { WsPageHeaderComponent } from './ws-page-header.component';
import { WsUiModule } from '@web/util/ws-ui/ws-ui.module';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    TranslateModule,
    DwsPermissionDirectiveModule,
    WsUiModule,
    FeatureToggleModule
],
  declarations: [WsPageHeaderComponent],
  exports: [WsPageHeaderComponent]
})
export class WsPageHeaderModule { }
